import { StorageService } from 'src/app/common/services/storage/storage.service';
import { CreateProformSubmissionAnswerPayload } from 'src/app/private/shared/types/payloads/proforms.payloads';

// For select dropdowns on creating & editing session
export const proFormQuestionTypes = [
  { label: 'Text', value: 'text' },
  { label: 'Long Text', value: 'textarea' },
  { label: 'Content Block', value: 'contentblock' },
  { label: 'Dropdown', value: 'dropdown' },
  { label: 'Radio', value: 'radio' },
  { label: 'Checkbox', value: 'checkbox' },
  { label: 'Attachment', value: 'attachment' },
  { label: 'Linear Scale', value: 'scale' },
  { label: 'Rubric', value: 'rubric' },
];

export const hasStoredFormData = (storageKey: string): boolean => {
  const latestData = StorageService.getItem(
    storageKey,
    Number.MAX_SAFE_INTEGER
  );
  return !!latestData?.answers;
};

export const getStoredFormData = (
  storageKey: string
): CreateProformSubmissionAnswerPayload[] | undefined => {
  const latestData = StorageService.getItem(
    storageKey,
    Number.MAX_SAFE_INTEGER
  );
  return latestData?.answers;
};
